import { jsxs, jsx } from "react/jsx-runtime";
import "../../../constants/index.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import { translate } from "../../../utils/misc.js";
const FieldHelperText = ({ t, classes, className, helperText, error, alwaysDisplay }) => {
  const { themeClasses } = useThemePresetClasses("FieldHelperText", classes, className);
  const isDisplay = alwaysDisplay || !!helperText;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("max-h-0", themeClasses == null ? void 0 : themeClasses.root, {
        "max-h-5": isDisplay
      }),
      children: [
        !!helperText && !alwaysDisplay && /* @__PURE__ */ jsx("div", { className: cn("h-5", themeClasses == null ? void 0 : themeClasses.helperText, error ? themeClasses == null ? void 0 : themeClasses.errorText : ""), children: translate(t, helperText) }),
        alwaysDisplay && /* @__PURE__ */ jsx("div", { className: cn("h-5", themeClasses == null ? void 0 : themeClasses.helperText, error ? themeClasses == null ? void 0 : themeClasses.errorText : ""), children: translate(t, helperText) })
      ]
    }
  );
};
const FieldHelperText$1 = FieldHelperText;
export {
  FieldHelperText$1 as default
};
